import { render } from "./PublishingEditForm.vue?vue&type=template&id=0da7fea5"
import script from "./PublishingEditForm.vue?vue&type=script&lang=js"
export * from "./PublishingEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__